// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3p4Nr","row":"styles_row__3D9KJ","moreInfo":"styles_moreInfo__1jzg4","containerRows":"styles_containerRows__3gG0b","table":"styles_table__3La57"};